import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";
import LocalFilePicker from "../components/associatedFiles/LocalFilePicker";
import AsyncLoadingButton from "../components/asyncLoadingButton/AsyncLoadingButton";
import LabelledSwitch from "../components/labelledSwitch/LabelledSwitch";
import ImageTagsSelect from "./ImageTagsSelect";
import SelectImageProducts from "./SelectImageProducts";

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onNewFile: (formData: FormData) => void | Promise<void>;
}

export const AddImageDialog: FC<Props> = ({ open, onClose, onNewFile }) => {
  const [tags, setTags] = useState<string[]>([]);
  const [file, setFile] = useState<File | undefined>(undefined);
  const [filename, setFilename] = useState("");
  const [info, setInfo] = useState("");
  const [source, setSource] = useState("");
  const [isPrivate, setIsPrivate] = useState(true);
  const [imageProducts, setImageProducts] = useState<string[]>([]);

  useEffect(() => {
    setTags([]);
  }, [open]);

  const handleChangeFile = (file?: File) => {
    setFilename(file?.name ?? "");
    setFile(file);
  };

  const handleAdd = async () => {
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("name", filename);
    formData.append("tags", JSON.stringify(tags));
    formData.append("products", JSON.stringify(imageProducts));
    formData.append("isPrivate", isPrivate.toString());
    if (info) {
      formData.append("info", info);
    }
    if (source) {
      formData.append("source", source);
    }
    await onNewFile(formData);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Dodaj grafikę</DialogTitle>
      <DialogContent>
        <Stack
          spacing={2}
          sx={{
            minWidth: "400px",
            marginTop: 1,
          }}
        >
          <LocalFilePicker label="Plik graficzny" accept="image/*" onFileChange={handleChangeFile} />
          <TextField label="Nazwa" fullWidth value={filename} onChange={(e) => setFilename(e.target.value)} />
          <ImageTagsSelect selectedValues={tags} fullWidth onSelectionChange={(v) => setTags(v)} />
          <TextField label="Źródło" fullWidth value={source} onChange={(e) => setSource(e.target.value)} />
          <TextField label="Info" fullWidth value={info} onChange={(e) => setInfo(e.target.value)} />
          <SelectImageProducts imageProducts={imageProducts} setImageProducts={setImageProducts} />
          <LabelledSwitch label="Prywatne" checked={isPrivate} onChange={(e) => setIsPrivate(e)} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          Anuluj
        </Button>
        <AsyncLoadingButton color="primary" disabled={!file} onClick={handleAdd}>
          Dodaj
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};
